import { useEffect } from 'react';

export const useScrollLock = (locked: boolean) => {
	useEffect(() => {
		if (!locked || typeof document === 'undefined') return;

		const html = document.documentElement;
		const { body } = document;
		const scrollBarWidth = window.innerWidth - html.clientWidth;
		const previous = {
			htmlOverflow: html.style.overflow,
			bodyOverflow: body.style.overflow,
			bodyPaddingRight: body.style.paddingRight,
		};

		html.style.overflow = 'hidden';
		body.style.overflow = 'hidden';
		if (scrollBarWidth > 0) {
			body.style.paddingRight = `${scrollBarWidth}px`;
		}

		return () => {
			html.style.overflow = previous.htmlOverflow;
			body.style.overflow = previous.bodyOverflow;
			body.style.paddingRight = previous.bodyPaddingRight;
		};
	}, [locked]);
};
